import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAttendanceTrackingAccess } from 'contexts/AttendanceTrackingAccessContext';

export const ProtectedRouteAttendanceTrackingAdmin = () => {
  const access = useAttendanceTrackingAccess();

  if (!access.isAdmin) {
    return <Navigate to="/attendance-tracking/upload" replace />;
  }

  return <Outlet />;
};
